/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Search_Guides_Gridcraft_Vs_Excel_Sections_0_Table_Rows_1_2Inputs */

const en_gc_search_guides_gridcraft_vs_excel_sections_0_table_rows_1_2 = /** @type {(inputs: Gc_Search_Guides_Gridcraft_Vs_Excel_Sections_0_Table_Rows_1_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Native Excel workflow; web and desktop capabilities differ.`)
};

const zh_gc_search_guides_gridcraft_vs_excel_sections_0_table_rows_1_2 = /** @type {(inputs: Gc_Search_Guides_Gridcraft_Vs_Excel_Sections_0_Table_Rows_1_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`原生 Excel 工作流程；网页版和桌面版能力不同。`)
};

/**
* | output |
* | --- |
* | "Native Excel workflow; web and desktop capabilities differ." |
*
* @param {Gc_Search_Guides_Gridcraft_Vs_Excel_Sections_0_Table_Rows_1_2Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_search_guides_gridcraft_vs_excel_sections_0_table_rows_1_2 = /** @type {((inputs?: Gc_Search_Guides_Gridcraft_Vs_Excel_Sections_0_Table_Rows_1_2Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Search_Guides_Gridcraft_Vs_Excel_Sections_0_Table_Rows_1_2Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_search_guides_gridcraft_vs_excel_sections_0_table_rows_1_2(inputs)
	return zh_gc_search_guides_gridcraft_vs_excel_sections_0_table_rows_1_2(inputs)
});
export { gc_search_guides_gridcraft_vs_excel_sections_0_table_rows_1_2 as "gc.search_guides.gridcraft_vs_excel.sections.0.table.rows.1.2" }